<!--p-dropdown [options]="options" *ngIf="options" [(ngModel)]="selectedValue" (onChange)="onOptionChange()"
            optionLabel="name" styleClass="option-to-close-renderer">
</p-dropdown-->
<irb-dropdown-filter
    #dropdownFilter
    [(value)]="selectedValue"
    (search)="populateDropdown($event)"
    (selection)="onOptionChange()"
    (keydown)="$event.stopPropagation()"
    [disabled]="disabled"
></irb-dropdown-filter>